import * as XLSX from 'xlsx';

export const exportToExcel = (analysisData: any) => {
    const workbook = XLSX.utils.book_new();

    // Chuẩn bị dữ liệu theo định dạng rõ ràng hơn
    const combinedData: any[] = [
        { Section: 'Basic Information', Key: '', Value: '' },
        ...Object.entries(analysisData.BasicInformation).map(([key, value]) => ({ Section: '', Key: key, Value: value })),

        { Section: 'Technical Analysis', Key: '', Value: '' },
        ...Object.entries(analysisData.TechnicalAnalysis).map(([key, value]) => ({ Section: '', Key: key, Value: value })),

        { Section: 'Liquidity Analysis', Key: '', Value: '' },
        ...Object.entries(analysisData.LiquidityAnalysis).map(([key, value]) => ({ Section: '', Key: key, Value: value })),

        { Section: 'Fundamental Analysis', Key: '', Value: '' },
        ...Object.entries(analysisData.FundamentalAnalysis).map(([key, value]) => ({ Section: '', Key: key, Value: value })),

        { Section: 'Price Prediction', Key: '', Value: '' },
        ...Object.entries(analysisData.PricePrediction).map(([key, value]) => ({ Section: '', Key: key, Value: value })),

        { Section: 'Investment Strategy', Key: '', Value: '' },
        ...Object.entries(analysisData.InvestmentStrategy).map(([key, value]) => ({ Section: '', Key: key, Value: value })),

        { Section: 'Risks to Consider', Key: '', Value: '' },
        ...analysisData.RisksToConsider.map((risk: string, index: number) => ({ Section: '', Key: `Risk ${index + 1}`, Value: risk }))
    ];

    // Chuyển đổi thành sheet Excel
    const sheet = XLSX.utils.json_to_sheet(combinedData);

    // Căn chỉnh cột
    const columnWidths = [
        { wch: 25 }, // Section
        { wch: 30 }, // Key
        { wch: 50 }  // Value
    ];
    sheet['!cols'] = columnWidths;

    // Thêm màu nền cho tiêu đề cột
    const range = XLSX.utils.decode_range(sheet['!ref']!);
    for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellRef = XLSX.utils.encode_cell({ r: 0, c: C });
        if (!sheet[cellRef]) continue;
        sheet[cellRef].s = {
            font: { bold: true, color: { rgb: 'FFFFFF' } },
            fill: { fgColor: { rgb: '4F81BD' } },
            alignment: { horizontal: 'center' }
        };
    }

    XLSX.utils.book_append_sheet(workbook, sheet, 'Stock Analysis');

    // Xuất file Excel
    XLSX.writeFile(workbook, `StockAnalysisReport(${new Date().toLocaleDateString()}).xlsx`);
};
